import { useMemo } from 'react';

// returns 0 for nothing selected, 1 for some selected and 2 for all selected
const useSelectionStatus = (data, selectedIds) => useMemo(() => {
  if (selectedIds.length) {
    if (selectedIds.length < data.length) {
      return 1;
    }
    if (selectedIds.length === data.length) {
      const intrstn = data.reduce((acc, { id }) => (selectedIds.includes(id) ? acc + 1 : acc), 0);
      if (intrstn === selectedIds.length) {
        return 2;
      }
      if (intrstn) {
        return 1;
      }
    }
  }
  return 0;
}, [data, selectedIds]);

export default useSelectionStatus;
